import { Typography } from '@mui/material';
import { useGetBusinessProfile } from 'apis/business/hook';
import React, { useEffect, useState } from 'react';

export default function Workflows() {
  const { data: businessProfile } = useGetBusinessProfile();
  const [folderId, setFolderId] = useState<string | null>(null);

  useEffect(() => {
    if (businessProfile) {
      const workspace = businessProfile.workspaces?.[0];
      if (workspace?.langflow_folder_id) {
        setFolderId(workspace.langflow_folder_id);
      }
    }
  }, [businessProfile]);

  const workflowSrc = `${process.env.REACT_APP_WORKFLOW_URL}/all/folder/${folderId || ''}`;

  if (!folderId) {
    return <div>No workspace or folder ID found.</div>;
  }

  return (
    <>
      <Typography variant='h2' fontWeight={500} mb={1}>
        Workflows
      </Typography>
      <iframe
        src={workflowSrc}
        title='Workflow'
        style={{ height: '100vh', width: '100%', padding: 0, margin: 0, border: 'none' }}
      />
      ;
    </>
  );
}
